import React from 'react';

import {Dialog} from 'shells/dialog/dialog';
import {Body} from 'shells/typography/body';

import {DirectorySyncConfigureButtons} from '..';

type Props = {
    canSetup: boolean;
    isConfigured: boolean;
    canConfigureDirectorySync: boolean;
    handleDisableDirectorySync: () => void;
    handleOpenAdminPortal: () => void;
    setIsFeatureGateModalOpen: (isOpen: boolean) => void;
};

export function DirectorySyncConfigure(props: Props) {
    const [isDisableDirectorySyncConfirmationOpen, setIsDisableDirectorySyncConfirmationOpen] =
        React.useState<boolean>(false);

    const disableRef = React.useRef<HTMLElement | null | undefined>(null);

    const handleDisableDirectorySync = () => {
        setIsDisableDirectorySyncConfirmationOpen(false);
        props.handleDisableDirectorySync();
    };

    return (
        <div>
            <div className='flex'>
                <Body size='small' isBold={true}>
                    Configure your directory sync
                </Body>
                <DirectorySyncConfigureButtons
                    canSetup={props.canSetup}
                    isConfigured={props.isConfigured}
                    canConfigureDirectorySync={props.canConfigureDirectorySync}
                    setIsFeatureGateModalOpen={props.setIsFeatureGateModalOpen}
                    handleOpenAdminPortal={props.handleOpenAdminPortal}
                    disableRef={disableRef}
                    setIsDisableDirectorySyncConfirmationOpen={
                        setIsDisableDirectorySyncConfirmationOpen
                    }
                />
            </div>
            <div className='flex'>
                {props.isConfigured ? (
                    <Body size='small' color='medium'>
                        Directory sync is on
                    </Body>
                ) : (
                    <Body size='small' color='medium'>
                        Directory sync is off
                    </Body>
                )}
            </div>
            {isDisableDirectorySyncConfirmationOpen && (
                <Dialog
                    anchor={disableRef.current}
                    question='Disabling this will reset your directory sync configuration. If you want to enable, you will have to start over.'
                    primaryText='Yes, disable'
                    primaryVariant='danger'
                    secondaryText='No, don’t disable'
                    secondaryVariant='secondary'
                    onPrimary={handleDisableDirectorySync}
                    onSecondary={() => setIsDisableDirectorySyncConfirmationOpen(false)}
                    location='bottom'
                    customStyles={{
                        width: '240px',
                    }}
                />
            )}
        </div>
    );
}
